/* eslint-disable no-nested-ternary */
import qs from 'qs';
import _size from 'lodash/size';
import _lowerCase from 'lodash/lowerCase';
import _isEmpty from 'lodash/isEmpty';
import merge from 'lodash/merge';
import _get from 'lodash/get';
import PubSub from 'pubsub-js';
import { showLoader, hideLoader } from './loader';
import { setCurrentFacets, setDeliveryFacets, setNextFacets } from './facets';
import fetcher from '../../modules/ajio-fetch';
import { showError } from './HTTPError';
import {
  fetchGetJSONReqOpts,
  getErrorStatusCode,
  getFetcherHeader,
  fetchGetJSONResHandler
} from '../../modules/ajio-fetch/utils';
import properties from '../../modules/ajio-util/properties';
import endpoints from '../../modules/ajio-util/endpoints';
import { getHostName } from '../../utils/sisUtils';
import { FLEEK_STORE } from '../../constants/constant';
import * as ga from '../../modules/ga';
import { errorProcessor } from '../../modules/ajio-fetch/errorProcessor';
import { gtmEventPush, gtmEventPushPLP, getStoreName } from '../../modules/ga/GTMdatalayer';
import { readClusterCookie, getCookie, readCookie } from '../../components/common/Cookie';
import { getJioAdsHeader } from '../../utils/jioAds';
import { getOsmosAdsInOrder } from '../../utils/osmosUtils';
import isNode from '../../modules/ajio-util/isNode';
// eslint-disable-next-line import/no-cycle
import { unratedRating } from '../ratings';
import { getFeatureVariant, getVariant } from '../../refresh/organism/ABFeature/Feature';
import {
  getSearchFlags,
  getReleaseGA4Flag,
  getMasterGA4Flag,
  getMasterGA3Flag,
  enableSearchV4Flag,
  getPriorityDeliveryPhase2Flag,
  getPriorityDeliverySLPTagsConfig,
  getUserRelevancy,
  getUrgencyDriverV2Config,
  getRushDeliveryFlag,
  getEnableFilterImprovement,
  getEnableFilterImprovementPhase2,
  getTrendBasedDiscoveryFlag,
  getVertexEnabledAjiogram,
  getVertexEnabledLuxe,
  getChildStores,
  getVertexEnabledForSis
} from '../../refresh/selectors/featureFlagsSelector';
import { getVertexQueryParams, isVertexExperimentFlagOn } from '../../refresh/utils/vertexUtils';
import { getSearchExpFlags, filterOutProperties} from '../../utils/products';
import { setPlpOnLandingResponse, updatePlpOnLandingResponse } from '../homeData';
import { getAmplitudeExperimentVariant, getAmplitudeVariantPayload } from '../../utils/amplitudeCommon';
import { getPreviousSearchSource } from '../../refresh/selectors/productpage';
import { SET_JIO_BANNER_ADS } from '../../constants/constant';
import { formatFacets } from '../../reducers/shared/facets'
import { sha256Hex } from '../../utils/products';

const url = properties.getProperty('cemUrl');
const apiUrl = properties.getProperty('apiUrl');

export function fetchingProducts(values) {
  return {
    type: 'FETCHING_PRODUCTS',
    values
  };
}
export function fetchingProductsSuccess(values) {
  return {
    type: 'FETCHING_PRODUCTS_SUCCESS',
    values
  };
}
export function fetchingProductsErrored(values) {
  return {
    type: 'FETCHING_PRODUCTS_ERRORED',
    values
  };
}
export function setPreviousSearchValues(values) {
  return {
    type: 'PREVIOUS_SEARCH_SOURCE',
    values
  };
}
export function setPageCategory(values) {
  return {
    type: 'SET_PAGE_CATEGORY',
    values
  };
}
export function loadingMoreItemsOnScroll(loadingMoreItems) {
  return {
    type: 'LOADING_MORE_PRODUCTS_ON_SCROLL',
    loadingMoreItems
  };
}
export function loadingMoreItemsOnScrollPDP(loadingMoreItems) {
  return {
    type: 'LOADING_MORE_PRODUCTS_ON_SCROLL_PDP',
    loadingMoreItems
  };
}
export function setViewType(viewType) {
  return {
    type: 'SET_VIEW_TYPE',
    viewType
  };
}
export function setGridData(data, idKey, query, pdpPage, plpViewType) {
  return {
    type: pdpPage ? 'SET_GRID_DATA_PDP' : 'SET_GRID_DATA',
    data,
    idKey,
    query,
    plpViewType
  };
}
export function setInterventionProducts(data, idKey, query, pdpPage, plpViewType) {
  return {
    type: 'SET_INTERVENTION_DATA_PDP',
    data,
    idKey,
    query,
    plpViewType
  };
}
export function setRequest(request) {
  return {
    type: 'SET_REQUEST',
    request
  };
}
export function setRequestPDP(requestPDP) {
  return {
    type: 'SET_REQUEST_PDP',
    requestPDP
  };
}
export function appendDataToGrid(data, idKey, query, pdpPage, plpViewType) {
  return {
    type: pdpPage ? 'APPEND_DATA_TO_GRID_PDP' : 'APPEND_DATA_TO_GRID',
    data,
    idKey,
    query,
    plpViewType
  };
}
export function setSorts(sorts) {
  return {
    type: 'SET_SORT_ITEMS',
    items: sorts
  };
}

export function getYouMayAlsoLike(obj) {
  return {
    type: 'YOU_MAY_ALSO_LIKE',
    obj
  };
}
export function getPlpExtendedBannerSuccess(data = {}) {
  return {
    type: 'GET_PLP_EXTENDED_BANNER_SUCCESS',
    data
  };
}
export function setProductOffSet(data){
  return {
    type: 'PREVIOUS_PRODUCT_OFFSET',
    data
  };
}
export function fetchOsmosBannerAds(values, facetValue = '', error = '') {
  return {
    type: SET_JIO_BANNER_ADS,
    values,
    error,
    facetValue
  };
}

export function setTrendsData(values = []) {
  return {
    type: 'SET_TRENDS_DATA',
    values
  };
}

function buildSearch(query) {
  const { fields, currentPage, pageSize, format, ...searchParams } = query;
  return `?${qs.stringify(searchParams)}`;
}
export function setAdditionalInfo(values) {
  return {
    type: 'SET_ADDITIONAL_INFO',
    values
  };
}

function isMobile() {
  let mobileDevice = false;
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    mobileDevice = true;
  }
  return mobileDevice;
}

async function getUnratedItems(req) {
  const headerInfo = getFetcherHeader(req);
  const UUID = req?.cookies?.CI || '';
  const apiEndpoint = `${url}/unratedItems/user/${UUID}`;
  const headers = {
    ...headerInfo,
    'X-Tenant-ID': 'ajio_b2c'
  };
  const method = 'GET';
  if (UUID) {
    let statusCode = null;
    return fetcher(apiEndpoint, fetchGetJSONReqOpts({ headers, method }))
      .then(resp => {
        statusCode = resp.status;
        if (resp.status === 200 && resp.ok) {
          return resp.json();
        }
        return Promise.reject(resp);
      })
      .then(response => {
        return {
          statusCode,
          response
        };
      })
      .catch(err => {
        return Promise.reject(err);
      });
  }
  return Promise.resolve({});
}

function deleteParams(queryObject, removeItems) {
  removeItems.forEach(element => {
    delete queryObject[element];
  });
  return queryObject;
}

function getAllUrlParams(url) {
  // get query string from url (optional) or window
  let queryString = url.split('?')[1];
  // we'll store the parameters here
  const obj = {};
  // if query string exists
  if (queryString) {
    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split('#')[0];
    // split our query string into its component parts
    const arr = queryString.split('&');
    for (let i = 0; i < arr.length; i++) {
      // separate the keys and the values
      const a = arr[i].split('=');
      // set parameter name and value (use 'true' if empty)
      const paramName = a[0];
      let paramValue = typeof a[1] === 'undefined' ? true : a[1];
      // (optional) keep case consistent
      // paramName = paramName.toLowerCase();
      if (typeof paramValue === 'string') paramValue = decodeURIComponent(paramValue);
      // if the paramName ends with square brackets, e.g. colors[] or colors[2]
      if (paramName.match(/\[(\d+)?\]$/)) {
        // create key if it doesn't exist
        const key = paramName.replace(/\[(\d+)?\]/, '');
        if (!obj[key]) obj[key] = [];
        // if it's an indexed array e.g. colors[2]
        if (paramName.match(/\[\d+\]$/)) {
          // get the index value and add the entry at the appropriate position
          const index = /\[(\d+)\]/.exec(paramName)[1];
          obj[key][index] = paramValue;
        } else {
          // otherwise add the value to the end of the array
          obj[key].push(paramValue);
        }
      } else {
        // we're dealing with a string
        if (!obj[paramName]) {
          // if it doesn't exist, create property
          obj[paramName] = paramValue;
        } else if (obj[paramName] && typeof obj[paramName] === 'string') {
          // if property does exist and it's a string, convert it to an array
          obj[paramName] = [obj[paramName]];
          obj[paramName].push(paramValue);
        } else {
          // otherwise add the property
          obj[paramName].push(paramValue);
        }
      }
    }
  }
  return obj;
}

function setDynamicProductWidgetDetails(apiEndPoint, storeval, cookies, requestHeaders, extras={}) {
  const {
    enableSearchV4Flag = false,
    isVertexCategoryEnabled = false,
    previousSource = '',
    isFilterImprovementEnabled = false,
    isFilterImprovementPhase2Enabled = false,
    filterImprovementPayload = {},
    isPLAEnabled = false, 
    plaAdsEliminationDisabled = false, 
    plpBannerAdsEnabled=false,
    enableSegmentIdVertex=false,
    visitorId = '',
    isVertexStoreScopeEnabled = true,
    isVisualFilterEnabled = false,
    vertexQueryParams = {}
  } = extras;
  const entries = getAllUrlParams(apiEndPoint);
  const { query = '', pageSize = 0, widgetLevel = '', heading = '', feedLogic = '', isCuratedWidget = false,widgetItemFilters='' } = entries;
  if (!storeval || storeval === '') storeval = 'rilfnl';
  const isOfferPriceABEnabled = getVariant('offerPrice');
  // const isWidgetIncludedVertex = widgetLevel.toLowerCase() !== 'user';
  const { PK= '', _ga= '', LS='', ZN='', ST='', CT='', customerType='', segment_device_id='' } = cookies;
  const userState = LS === 'LOGGED_IN' ? 'LOGGED_IN' : 'NON_LOGGED_IN';
  const isLoggedIn = LS === 'LOGGED_IN';
  const { CI: userId, A: token } = cookies;

  const encryptedUserId = isLoggedIn ? sha256Hex(userId) : sha256Hex(segment_device_id);
  const vertexQuery = { 
    vertexEnabled: isVertexCategoryEnabled,
    ...(visitorId && { visitorId }),
    ...(previousSource ? { previousSource } : {}),
    ...(encryptedUserId && { userEncryptedId: encryptedUserId })
  };

  const isAjioStore = ['', 'ajio', 'rilfnl'].includes(storeval);
  if (isAjioStore) storeval = 'ajio';

  let queryParams = {
    ...entries,
    newin: false,
    store: storeval,
    offer_price_ab_enabled: isOfferPriceABEnabled,
    widgetID: feedLogic, // feedLogic change TOC
    widgetType: widgetLevel,
    widgetMinProdCount: pageSize,
    widgetName: heading,
    showViewAllWidget: true,
    q: query,
    ...(isVertexCategoryEnabled && isCuratedWidget ? { ...vertexQuery }: {}),
    ...vertexQueryParams,
    plaAdsProvider: isPLAEnabled ? 'OSMOS' : 'JIOADS',
    plaAdsEliminationDisabled,
    plpBannerAdsEnabled,
    zone: ZN,
    state: ST, 
    city: CT, 
    userRestriction: customerType,
    userState,
    ...((isVertexCategoryEnabled || isPLAEnabled) && {encryptedUserId: isLoggedIn ? sha256Hex(userId): sha256Hex(segment_device_id)}),
    ...(isFilterImprovementEnabled ? filterImprovementPayload : {})
  };

  if(widgetLevel.toLowerCase() === 'user'){
    queryParams.userId = userId;
    requestHeaders.headers.Authorization = `Bearer ${token}`;
  }
  queryParams = deleteParams(queryParams, [
    'isDynamicWidget',
    'heading',
    'widgetLevel',
    'feedLogic',
    'isCuratedWidget'
  ]);
  if(isCuratedWidget === false || isCuratedWidget === 'false'){
    queryParams = deleteParams(queryParams, [
      'widgetItemFilters'
    ]);
  }

  const dynamicWidgetRilWebServiceUrl = (() => {
    if (isFilterImprovementPhase2Enabled) {
      return '/rilfnlwebservices/v7/rilfnl/';
    }

    if (isFilterImprovementEnabled) {
      return '/rilfnlwebservices/v6/rilfnl/';
    }

    return isVertexCategoryEnabled ? '/rilfnlwebservices/v2/rilfnl/' : '/rilfnlwebservices/rilfnl/';
  })();
  const ajioParentUrl = properties.getProperty('parentUrl');
  const isNodeCall = isNode();
  let parentUrl = isNodeCall ? apiUrl : ajioParentUrl;
  if (!isNodeCall) {
    const luxeParentUrl = properties.getProperty('luxeURL');
    const streetParentUrl = properties.getProperty('streetURL');
    const ajiogramUrl = properties.getProperty('fleekURL');
    if (storeval === 'luxe') parentUrl = luxeParentUrl;
    if (storeval === 'street') parentUrl = streetParentUrl;
    if (storeval === 'ajiogram') parentUrl = ajiogramUrl;
  }
  const dynamicApiEndPoint = `${parentUrl}${dynamicWidgetRilWebServiceUrl}products/widgets/83?${qs.stringify(
    {
      ...queryParams,
      ...(isVisualFilterEnabled && { visualFiltersEnabled: true, SearchFlag1: true })
    }
  )}`;
  return dynamicApiEndPoint;
}

function extractVisitorId(gaValue = '') {
  if(!gaValue) {
    return '';
  }
  const parts = gaValue.split('.');
  if (parts.length >= 4) {
    return parts[2] + '.' + parts[3];
  }
  return '';
}

export function fetchProducts({
  request = {},
  appendNewProducts = false,
  fetchProducts = true,
  fetchFacetsOnly = false,
  browserRequest = {},
  isRequestOrginIsBrowser = false,
  cid = '',
  capsuleLoader = '',
  store = '',
  enableClusterFeatureflag,
  cluster,
  plpAds,
  slpAds,
  isSearchPage = false,
  showAdsOnNextPage = false,
  enableAdsOnPlpFlag = false,
  enableAdsOnSlpFlag = false,
  enableEarlyAccessFlag = false,
  userAgent = '',
  previousSource = '',
  isOspreySearchEnabled: ospreySearch = '',
  isInterventionProducts = false,
  enablePDPhase2 = false,
  pdSLPTagsConfig = {},
  searchAuth = '',
  searchUserId = '',
  userRelevancyFlag = false,
  isVertexSearchEnabled = false,
  isVertexCategoryEnabled = false,
  updatedVisitorId: visitorId = '',
  enableSearchV4Endpoints = false,
  isRequestFromPlpOnLanding = false,
  displayProductsOnLandingLoader = false,
  isPlpOnLandingPage = false,
  isPlpOnLandingLoadMore = false,
  plpOnLandingFeedLogic = {},
  callBack = () => {},
  isPriceFilterFromPlpLandingPage = false,
  enableRushDelivery=false,
  isVertexSuggestion = false,
  urgencyDriverV2MsiteConfig: serverUrgencyDriverV2MsiteConfig = {},
  isFilterImprovementEnabled = false,
  isFilterImprovementPhase2Enabled = false,
  isPLAEnabled = false,
  plaAdsEliminationDisabledFlag = false,
  plpBannerAdsEnabled=false,
  zone= '',
  state= '', 
  city= '', 
  userRestriction= '',
  userState='',
  osmosPlpBannerSlotsOrder={},
  customerUID='',
  segmentAnonymousId,
  isTrendBasedDiscoveryFlag = false,
  trendBasedDiscoveryFlag = {},
  isVisualFilterEnabled = false,
  vertexEnabledAjiogram = {},
  vertexEnabledLuxe = {},
  childStores = [],
  vertexEnabledForSis = false,
  isVisualFilterInteraction = false
}) {
  console.log("======= DEBUGGING POINT 0 =============")
  const { sortBy, autoSuggestType = '', ...rest } = request.query ?? {};
  const { sortBy: defautSortBy, ...restQueryParams } = request.defaultQuery ?? {};
  delete request?.query?.sortBy;
  delete request?.defaultQuery?.sortBy;
  // sort is not required in the /search requests 
  if (!request?.pathname?.includes('/search')) {
    request.query = { ...rest, sort: sortBy };
    request.defaultQuery = { ...restQueryParams, sort: defautSortBy };
  }


  const { curatedQuery = {} } = request;
  let requestHeader = {};
  const { deviceType = '', query: { isDynamicWidget = '', isCuratedWidget = '' } = {} } = request;
  let { headerInfo = {} } = request;
  if (_isEmpty(headerInfo)) {
    headerInfo = getFetcherHeader(request);
  }

  if (request.query?.brandPageCode && store === FLEEK_STORE) {
    request.query.brandCode = request.query.brandPageCode;
    delete request.query.brandPageCode;
  }

  if (request.query?.brandPageId && store === FLEEK_STORE) {
    delete request.query.brandPageId;
  }

  // if (enableClusterFeatureflag) {
  //   if (isRequestOrginIsBrowser) {
  //     userClusterId = readClusterCookie('cluster', store);
  //   } else {
  //     const { cookies: { cluster: clusterCookie } = {} } = request;
  //     userClusterId = readClusterCookie(clusterCookie || cluster, store);
  //   }
  // }

  // will be set as string true and false, just to identify if it is set or not
  // enableAdsOnPlpCookie = 'true' or 'false'  => only set if expirement running and its variant
  let enableAdsOnPlpCookie = '';
  if (isRequestOrginIsBrowser) {
    enableAdsOnPlpCookie = readCookie('plpAds');
  } else {
    const { cookies: { plpAds: plpAdsCookie } = {} } = request;
    enableAdsOnPlpCookie = plpAdsCookie || plpAds;
  }

  // eslint-disable-next-line camelcase
  let is_ads_enable_plp = enableAdsOnPlpFlag;
  // check if cookie is present
  if (enableAdsOnPlpCookie) {
    // eslint-disable-next-line camelcase
    is_ads_enable_plp = Boolean(enableAdsOnPlpCookie);
  }
  is_ads_enable_plp = store === FLEEK_STORE ? false : is_ads_enable_plp;

  // slp flag and variant
  // will be set as string true and false, just to identify if it is set or not
  // enableAdsOnSlpCookie = 'true' or 'false'  => only set if expirement running and its variant
  let enableAdsOnSlpCookie = '';
  let LSCookie = '';
  let sgAnonymousId = '';
  let isLoggedIn;
  console.log("======= DEBUGGING POINT 1 =============")

  if (isRequestOrginIsBrowser) {
    enableAdsOnSlpCookie = readCookie('slpAds');
    LSCookie = readCookie('LS');
    sgAnonymousId= readCookie('segment_device_id') || segmentAnonymousId;
  } else {
    const { cookies: { slpAds: slpAdsCookie, LS='', segment_device_id='' } = {} } = request;
    enableAdsOnSlpCookie = slpAdsCookie || slpAds;
    LSCookie = LS;
    sgAnonymousId= segment_device_id || segmentAnonymousId;
  }
  console.log("======= DEBUGGING POINT 2 =============")

  isLoggedIn = LSCookie === 'LOGGED_IN';
  // eslint-disable-next-line camelcase
  let is_ads_enable_slp = enableAdsOnSlpFlag;
  // check if cookie is present
  if (enableAdsOnSlpCookie) {
    // eslint-disable-next-line camelcase
    is_ads_enable_slp = Boolean(enableAdsOnSlpCookie);
  }
  is_ads_enable_slp = store === FLEEK_STORE ? false : is_ads_enable_slp;

  let platform = 'Desktop';
  if (deviceType && deviceType === 'desktop') {
    platform = 'Desktop';
  } else if (deviceType && deviceType === 'mobile') {
    platform = 'Msite';
  }
  const isMsite = platform === 'Msite';
  return async (dispatch, getState) => {
    dispatch(
      fetchingProducts({
        isRequestOrginIsBrowser,
        hasErrored: false,
        errorDetails: {}
      })
    );

    const states = getState();
    
    if (!request?.query?.visualFiltersState && states?.facets?.visualFiltersState) {
      request.query.visualFiltersState = states?.facets?.visualFiltersState;
    }

    if(!isVisualFilterInteraction && states?.facets?.visualFiltersState){
      request.query.visualFiltersState = states?.facets?.visualFiltersState;
    } 
    const { CI: userId, A: token, productListsOffset: cookieOffset } = request.cookies || {};
    let { currentPage = 0 } = request.query || {};
    let storedOffset = null;
    let enableUserRelevancy = false

    if(!isRequestOrginIsBrowser){
      enableUserRelevancy = userRelevancyFlag
    }
    if(isRequestOrginIsBrowser){
      enableUserRelevancy = getUserRelevancy((states?.flags)); 
    }

    if (currentPage === 0) {
      console.log("stored offset value 1",storedOffset)
    } else if (currentPage === 1) {
      storedOffset = states.product.productListsOffset || "";
    } else {
      storedOffset = sessionStorage.getItem("productListsOffset") || "";
    }

    if (!capsuleLoader && isRequestOrginIsBrowser) {
      dispatch(showLoader('products-loader'));
    }

    if (isVisualFilterInteraction) {
      dispatch(showLoader('visual-filter-loader'));
    }

    if (isRequestFromPlpOnLanding && displayProductsOnLandingLoader) {
      dispatch(showLoader('fetching-filtered-products-on-landing'));
    }

    if (request.query.hasOwnProperty('pageSize')) {
      if (isRequestOrginIsBrowser) {
         if(!isInterventionProducts){
          request.query.pageSize = isMobile() ? 15 : 45;
        }
      } 
       else {
        request.query.pageSize = request.deviceType.toLowerCase() === 'desktop' ? 45 : 15;
      }
    }

    if (isPlpOnLandingLoadMore && isRequestOrginIsBrowser) {
      request.query.pageSize = 20;
    }

    let segmentIdsList = '';
    let cohortHeaderValue = '';
    let customertype;
    const searchAbFlagObj = request?.query?.searchAbFlagObj;
    let enableSearchV4Flag = false
    if(!isRequestOrginIsBrowser){
      enableSearchV4Flag = enableSearchV4Endpoints
    }else{
      enableSearchV4Flag = states?.flags?.enableSearchV4Endpoints === 'ON';
    }
    if (
      request.pathname?.includes('products/category') ||
      request.pathname?.includes('/s/') ||
      request.pathname?.includes('/search') ||
      request.pathname?.includes('/find')
    ) {
      if (request.query.segmentIds) {
        segmentIdsList = request.query.segmentIds;
        delete request.query.segmentIds;
      }

      const { query: { cohortIds = '', customerType = '' } = {} } = request;

      delete request.query?.searchAbFlagObj;
      if (cohortIds && !isRequestOrginIsBrowser) {
        cohortHeaderValue = cohortIds;
        customertype = customerType;
        delete request.query.cohortIds;
        delete request.query.customerType;
      }
    }
   
    if(enableSearchV4Flag && (request.pathname?.includes('products') || request.pathname?.includes('search'))) {
      request = {
        ...request,
        pathname : request.pathname.replace('/v2/', '/v4/')
      }
    }

    if (enableUserRelevancy && (request.pathname?.includes("products") || request.pathname?.includes("search"))) {
      request = {
        ...request,
        pathname: request.pathname.replace(/\/v2\/|\/v4\//, "/v5/")
      };
    }

    const {
      pincode: pincodeFromQuery = '',
      latitude: latFromQuery = '',
      longitude: longFromQuery = ''
    } = request.query || {};
    ['pincode', 'latitude', 'longitude'].forEach(key => delete request.query[key]);
    let { query : queryData, trendId = "", tagName = "", isTrendWidget = '', type: trendType = '', value: brickValue = '' } = request.query;
    if(isTrendBasedDiscoveryFlag && isMsite){
      if(isTrendWidget === "true" && trendId && states?.products.trendsData?.length){
        const trendData = states?.products.trendsData?.filter(item => item?.trendId === trendId);
        queryData = trendData?.[0]?.redirectQuery || queryData || '';
      } else if(isTrendWidget === "true" && tagName){
        queryData = `${trendBasedDiscoveryFlag?.pdp?.trendsQuery}${tagName}`
      } else if(isTrendWidget === "false" && tagName) {
        queryData = `${trendBasedDiscoveryFlag?.pdp?.vibeQuery}${tagName}`
      } else if(isTrendWidget === "true" && states?.products.trendsData?.length){
        queryData = states?.products?.trendsData?.[0]?.redirectQuery
      }
      if ((isTrendWidget === 'true' || isTrendWidget === 'false') && trendType?.toLowerCase() === 'brick' && brickValue) {
        const facetsStr = request.query?.facets || '';
        if (!facetsStr || facetsStr.includes('l1l3nestedcategory')) {
          queryData = `${queryData}:l1l3nestedcategory:${brickValue}`;
        }
      }
    }
    let storeval = store;
    let apiEndPoint = `${request.pathname}?${qs.stringify({
      ...request.query,
      query: queryData,
      advfilter: true,
      platform,
      showAdsOnNextPage,
      is_ads_enable_plp,
      displayRatings: store === FLEEK_STORE ? false : true
    })}`;

    if (request.pathname?.includes('/s1/') && isRequestOrginIsBrowser) {
      apiEndPoint = request.pathname || `/c/${encodeURIComponent(cid)}`;
      apiEndPoint = `${apiEndPoint}?${qs.stringify({
        ...request.query,
        advfilter: true,
        displayRatings: store === FLEEK_STORE ? false : true
      })}`;
    } else if (request.pathname?.includes('/s1/') && !isRequestOrginIsBrowser) {
      const ABFlagObj = (searchAbFlagObj && JSON.parse(searchAbFlagObj)) || {};
      // due to prod bug https://devops.jio.com/Retail/E-Com_DCFL/_workitems/edit/342055
      // I m deleting the fields from the request.query, as it is added twice this way
      delete request.query?.fields;
      const categoryEndpoint = enableSearchV4Flag ? endpoints.get('categoryV4') : endpoints.get('category');

      apiEndPoint = `${categoryEndpoint}/${encodeURIComponent(
        cid
      )}?fields=SITE&uiel=Desktop&${qs.stringify({
        ...request.query,
        advfilter: true,
        platform,
        showAdsOnNextPage,
        is_ads_enable_plp,
        displayRatings: store === FLEEK_STORE ? false : true,
        ...ABFlagObj,
        store: storeval,
        ...(previousSource && { previousSource })
      })}`;
    }
    if (request.pathname?.includes('/s/') && isRequestOrginIsBrowser) {
      apiEndPoint = request.pathname || `/c/${encodeURIComponent(cid)}`;
      apiEndPoint = `${apiEndPoint}?${qs.stringify({
        ...request.query,
        advfilter: true,
        displayRatings: store === FLEEK_STORE ? false : true,
        ...(previousSource && { previousSource }),
      })}`;
    } else if (request.pathname?.includes('/s/') && !isRequestOrginIsBrowser) {
      const ABFlagObj = (searchAbFlagObj && JSON.parse(searchAbFlagObj)) || {};
      // due to prod bug https://devops.jio.com/Retail/E-Com_DCFL/_workitems/edit/342055
      // I m deleting the fields from the request.query, as it is added twice this way
      delete request.query?.fields;
      let categoryEndpoint = enableUserRelevancy
      ? endpoints.get('categoryV5') 
      : enableSearchV4Flag
      ? endpoints.get('categoryV4')  
      : endpoints.get('category');

      if (isFilterImprovementEnabled) {
        categoryEndpoint = endpoints.get(
          isFilterImprovementPhase2Enabled ? 'categoryV7' : 'categoryV6'
        );
      }
      const filterImprovementPayload = {
        sessionGenderContext: states?.facets?.sessionGenderContext || null,
        plpGender: states?.facets?.plpGender || null
      };

      if (isFilterImprovementEnabled && enableUserRelevancy) {
        categoryEndpoint = endpoints.get('personalisedCategory');
      }

      apiEndPoint = `${categoryEndpoint}/${encodeURIComponent(
        cid
      )}?fields=SITE&uiel=Desktop&${qs.stringify({
        ...request.query,
        advfilter: true,
        platform,
        showAdsOnNextPage,
        is_ads_enable_plp,
        displayRatings: store === FLEEK_STORE ? false : true,
        ...ABFlagObj,
        ...(isFilterImprovementEnabled && states?.facets?.sessionGenderContext && states?.facets?.plpGender && filterImprovementPayload),
        ...(isVisualFilterEnabled && isMsite && { visualFiltersEnabled: true, SearchFlag1: true }),
        store: storeval,
        ...(previousSource && { previousSource })
      })}`;
    }

    // if(request.pathname?.includes("/p/") && isRequestOrginIsBrowser){
    //   apiEndPoint = request.pathname || `/c/${cid}`;
    //   apiEndPoint = `${apiEndPoint}?${qs.stringify({...request.query, advfilter:true})}`;
    // } else if(request.pathname?.includes("/p/") && !isRequestOrginIsBrowser) {
    //   apiEndPoint = `${endpoints.get("category")}/${cid}?fields=SITE&uiel=Desktop&${qs.stringify({...request.query, advfilter: true})}`
    // }


    // for client side req, we will take values from client cookies
    if(isRequestOrginIsBrowser){
      ospreySearch = states?.flags?.enableOspreySearch === 'ON';
      isVertexSearchEnabled = states?.flags?.vertexEnabled === 'ON';
      isVertexCategoryEnabled= (getAmplitudeVariantPayload('enableCategoryWidgetsVertex', states, false) && getAmplitudeExperimentVariant('vertex-exp-flag',states));
      let enableSegmentIdVertex= getAmplitudeVariantPayload('enableSegmentIdVertex', states, false);

      visitorId = enableSegmentIdVertex ? readCookie('segment_device_id') : extractVisitorId(readCookie('_ga'));
      customerUID = readCookie('CI') || '';
      previousSource = getPreviousSearchSource(states);
    }

    let storeNameValue ='';
    if(isRequestOrginIsBrowser){
       storeNameValue = getStoreName() || '';
    } else {
      storeNameValue = store;
    }
    console.log('store name', storeNameValue);  
    const searchStore = storeNameValue === '' || storeNameValue === 'ajio';
    const searchAjioStore = storeNameValue === '' || storeNameValue === 'ajio' || storeNameValue === 'rilfnl';
    const isAjioStoreOspreySearch = ospreySearch && searchStore;

    // Send store only when Vertex search is enabled for Ajiogram/Luxe; always send for SIS/AJIO
    const vertexEnabledAjiogramState = getVertexEnabledAjiogram(states);
    const vertexEnabledLuxeState = getVertexEnabledLuxe(states);
    const activeVertexAjiogram = isRequestOrginIsBrowser
      ? vertexEnabledAjiogramState
      : vertexEnabledAjiogram;
    const activeVertexLuxe = isRequestOrginIsBrowser ? vertexEnabledLuxeState : vertexEnabledLuxe;

    const isSearchRoute =
      request.pathname?.includes('/search') || request.pathname?.includes('/find');
    const isBrowseRoute =
      request.pathname?.includes('/category') || request.pathname?.includes('/widgets') || request.pathname?.includes('/s/') || request.pathname?.includes('/s1/');
    const normalizedStore = (storeNameValue || '').toLowerCase();
    const encryptedUserId = isLoggedIn ? sha256Hex(customerUID) : sha256Hex(sgAnonymousId);

    let vertexQueryParams = {};
    if (isRequestOrginIsBrowser) {
      vertexQueryParams = getVertexQueryParams(
        states,
        storeNameValue,
        request.pathname,
        visitorId,
        encryptedUserId
      );
      if (
        !Object.keys(vertexQueryParams).length &&
        !['ajiogram', 'luxe'].includes(normalizedStore)
      ) {
        const childStoresFromState = (getChildStores(states) || []).map(s => s.toLowerCase());
        if (getVertexEnabledForSis(states) && childStoresFromState.includes(normalizedStore)) {
          vertexQueryParams = {
            vertexEnabled: true,
            ...(visitorId && { visitorId }),
            ...(encryptedUserId && { userEncryptedId: encryptedUserId })
          };
        }
      }
    } else if (['ajiogram', 'luxe'].includes(normalizedStore)) {
      const storeConfig = normalizedStore === 'ajiogram' ? vertexEnabledAjiogram : vertexEnabledLuxe;
      if (storeConfig?.master) {
        const isEnabled = (isSearchRoute && storeConfig?.vertexSearchEnabled) || (isBrowseRoute && storeConfig?.vertexBrowseEnabled);
        if (isEnabled) {
          vertexQueryParams = {
            vertexEnabled: true,
            ...(visitorId && { visitorId }),
            ...(encryptedUserId && { userEncryptedId: encryptedUserId })
          };
        }
      }
    } else if (vertexEnabledForSis && (childStores || []).map(s => s.toLowerCase()).includes(normalizedStore)) {
      vertexQueryParams = {
        vertexEnabled: true,
        ...(visitorId && { visitorId }),
        ...(encryptedUserId && { userEncryptedId: encryptedUserId })
      };
    }

    if (autoSuggestType?.length && !isVertexSuggestion) {
      vertexQueryParams = {};
    }

    const isVertexStoreScopeEnabled =
      // Ajiogram
      (normalizedStore === 'ajiogram' &&
        ((isSearchRoute && isVertexExperimentFlagOn(activeVertexAjiogram?.vertexSearchEnabled)) ||
          (isBrowseRoute && isVertexExperimentFlagOn(activeVertexAjiogram?.vertexBrowseEnabled)))) ||
      // Luxe
      (normalizedStore === 'luxe' &&
        ((isSearchRoute && isVertexExperimentFlagOn(activeVertexLuxe?.vertexSearchEnabled)) ||
          (isBrowseRoute && isVertexExperimentFlagOn(activeVertexLuxe?.vertexBrowseEnabled)))) ||
      // All other stores → always send
      !['ajiogram', 'luxe'].includes(normalizedStore);

    let enableRushDeliveryFlag = getRushDeliveryFlag(states) || enableRushDelivery;
    let enablePriorityDeliveryPhase2 = getPriorityDeliveryPhase2Flag(states?.flags) || enablePDPhase2;
    let priorityDeliverySLPTagsConfig = getPriorityDeliverySLPTagsConfig(states) || pdSLPTagsConfig;
    if (Object.keys(priorityDeliverySLPTagsConfig).length === 0) {
      priorityDeliverySLPTagsConfig = pdSLPTagsConfig;
    }

    const {
      PC: savedPincodeVal = '',
      RushLocationCoords: savedRushCoords = '',
      RushAvail: savedRushAvail = ''
    } = request.cookies || {};
    
    let pincode = savedPincodeVal || pincodeFromQuery;
    let rushLocationCoords = savedRushCoords;
    let rushAvail = savedRushAvail;

    let { lat = '', long = '' } = (rushLocationCoords && JSON.parse(rushLocationCoords)) || {};
    let { rushDelivery: rushDeliveryAvailability = false } =
      (rushAvail && JSON.parse(rushAvail)) || {};
    let latitude = lat || latFromQuery;
    let longitude = long || longFromQuery;

    if (isRequestOrginIsBrowser) {
      pincode = readCookie('PC');
      rushLocationCoords = readCookie('RushLocationCoords');
      rushAvail = readCookie('RushAvail');

      const { lat: browserLat = '', long: browserLong = '' } =
        (rushLocationCoords && JSON.parse(rushLocationCoords)) || {};
      const { rushDelivery: browserRushDelivery = false } =
        (rushAvail && JSON.parse(rushAvail)) || {};
      latitude = browserLat || latitude;
      longitude = browserLong || longitude;
      rushDeliveryAvailability = browserRushDelivery || rushDeliveryAvailability;
    }

    const pincodeObj =
      (enableRushDeliveryFlag || enablePriorityDeliveryPhase2) &&
      pincode &&
      !apiEndPoint.includes('pincode=')
        ? { pincode: pincode }
        : {};

    const locationCoordsObj =
      enableRushDeliveryFlag &&
      rushDeliveryAvailability &&
      latitude &&
      longitude &&
      !apiEndPoint.includes('latitude=') &&
      !apiEndPoint.includes('longitude=')
        ? { latitude, longitude }
        : {};
    const enableRushObj = enableRushDeliveryFlag ? { enableRushDelivery: true } : {enableRushDelivery: false };
    if (
      (request.pathname?.includes('/search') || request.pathname?.includes('/find')) &&
      !isRequestOrginIsBrowser
    ) {
      const ABFlagObj = (searchAbFlagObj && JSON.parse(searchAbFlagObj)) || {};

      let searchEndpoint = enableUserRelevancy
      ? endpoints.get('searchV5') 
      : enableSearchV4Flag
      ? endpoints.get('searchV4')  
      : endpoints.get('search'); 

      if (isVertexSearchEnabled && isVertexSuggestion) {
        searchEndpoint = endpoints.get('searchV4');
      }

      if (isFilterImprovementEnabled) {
        searchEndpoint = endpoints.get(isFilterImprovementPhase2Enabled ? 'searchV7' : 'searchV6');
      }
      const filterImprovementPayload = {
        sessionGenderContext: states?.facets?.sessionGenderContext || null,
        plpGender: states?.facets?.plpGender || null
      };

      apiEndPoint = `${searchEndpoint}?${qs.stringify({
        ...request.query,
        advfilter: true,
        platform,
        is_ads_enable_plp: isAjioStoreOspreySearch ? false : is_ads_enable_plp,
        is_ads_enable_slp,
        showAdsOnNextPage,
        displayRatings: store === FLEEK_STORE ? false : true,
        // userEncryptedId: sha256Hex(customerUID),        
        ...enableRushObj,
        ...ABFlagObj,
        ...pincodeObj,
        ...locationCoordsObj,
        ...(isAjioStoreOspreySearch && { ospreySearch }),
        ...(searchAjioStore && {vertexEnabled : isVertexSearchEnabled}),
        ...(isVertexSearchEnabled && searchAjioStore && {visitorId}),
        ...vertexQueryParams,
        ...(isFilterImprovementEnabled && states?.facets?.sessionGenderContext && states?.facets?.plpGender && filterImprovementPayload),
        ...(isVisualFilterEnabled && isMsite && { visualFiltersEnabled: true, SearchFlag1: true })
      })}`;
    } else if (
      (request.pathname?.includes('/search') || request.pathname?.includes('/find')) &&
      isRequestOrginIsBrowser
    ) {
      const isFilterImprovementEnabledFromClientSide = getEnableFilterImprovement(states);
      const filterImprovementPayload = {
        sessionGenderContext: states?.facets?.sessionGenderContext || null,
        plpGender: states?.facets?.plpGender || null
      };

      //client call for search
      if (request.query.query && !request.query.query.startsWith(request.freeTextSearch)) {
        request.query.query = `${request.freeTextSearch}${request.query.query}`;
      }
      apiEndPoint = `${request.pathname}` || `/search/${encodeURIComponent(cid)}`;
      apiEndPoint = `${apiEndPoint}?${qs.stringify({
        ...request.query,
        advfilter: true,
        platform,
        is_ads_enable_plp: isAjioStoreOspreySearch ? false : is_ads_enable_plp,
        is_ads_enable_slp,
        showAdsOnNextPage,
        displayRatings: store === FLEEK_STORE ? false : true,
        // userEncryptedId: sha256Hex(customerUID),
        ...enableRushObj,
        ...pincodeObj,
        ...locationCoordsObj,
        ...(isAjioStoreOspreySearch && { ospreySearch }),
        ...(previousSource && { previousSource }),
        ...(searchAjioStore && {vertexEnabled : isVertexSearchEnabled}),
        ...(isVertexSearchEnabled && searchAjioStore && visitorId && { visitorId }),
        ...vertexQueryParams,
        ...(isFilterImprovementEnabledFromClientSide && states?.facets?.sessionGenderContext && states?.facets?.plpGender && filterImprovementPayload)
      })}`;
    }

    if (request.pathname?.includes('/cp/') && isRequestOrginIsBrowser) {
      apiEndPoint = `${request.pathname}/${encodeURIComponent(cid)}?${qs.stringify({
        ...request.query,
        advfilter: true,
        displayRatings: store === FLEEK_STORE ? false : true
      })}`;
    } else if (request.pathname?.includes('/cp/') && !isRequestOrginIsBrowser) {
      apiEndPoint = `${endpoints.get('capsulecp')}/${encodeURIComponent(cid)}?${qs.stringify({
        ...request.query,
        advfilter: true,
        displayRatings: store === FLEEK_STORE ? false : true
      })}`;
    }

    if (request.pathname?.includes('/capsule/') && !isRequestOrginIsBrowser) {
      // apiEndPoint = `${endpoints.get("newin")}/?pageId=/capsule/newin&fields=BASIC&format=json`
      apiEndPoint = `${endpoints.get('capsulecp')}/${encodeURIComponent(cid)}`;
    }

    // Initializing a flag to determine if the brand name includes default routes like wishlist, cart, or shipping.
    let brandNameIncludesDefaultRoutes = false;
    let brandSegment = '';

    // Check if the request object has a browserPath property.
    if(request?.pathname){
      // Extract the brand segment from the browser path by splitting the path at '/b/'.
      brandSegment =
        request?.pathname.split('/s/')[1] ||
        request?.pathname.split('/b/')[1] ||
        request?.pathname.split('/fb/')[1];
    }

    // If the brand segment is found, check if it includes any of the default routes.
    if(brandSegment){
      brandNameIncludesDefaultRoutes = brandSegment.includes('wishlist') || brandSegment.includes('cart') || brandSegment.includes('shipping');
    }

    // Check if the pathname includes wishlist, cart, or shipping and ensure the brand name does not include these default routes.
    if (
      (request.pathname?.includes('/wishlist') ||
      request.pathname?.includes('/cart') ||
      request.pathname?.includes('/shipping')) && (!brandNameIncludesDefaultRoutes)
    ) {
      const { A: token = '', U: userName = '', CI: customerUuid = '' } = request.cookies || {};
      const {
        currentPage = 0,
        batchId = false,
        segmentIds,
        cohortIds,
        customerType
      } = request.query;
      // apiEndPoint = !isRequestOrginIsBrowser ? `${properties.getProperty(
      //       'wishlist'
      //     )}/rilfnlwebservices/v2/rilfnl/${userName}/wishlist/?currentPage=${currentPage}&pageSize=10&client_type=${client_type}`
      //   : `/api/wishlist/getwishlist?currentPage=${currentPage}&pageSize=10`;
      // if (batchId && !isRequestOrginIsBrowser) {
      //   apiEndPoint = `${properties.getProperty(
      //     'wishlist'
      //   )}/wishlist/rilfnl/v2/viewall/user/${customerUuid}?currentPage=${currentPage}&pageSize=10`;
      // }
      // if(customerUuid){
        apiEndPoint = !isRequestOrginIsBrowser
          ? `${properties.getProperty(
              'wishlistUrl'
            )}/wishlist/service/view/${customerUuid}?currentPage=${currentPage}&pageSize=10&segmentIds=${segmentIds ||
              null}&userClusterId=${cohortIds}&customertype=${customerType}`
          : `/api/wishlist/getwishlist?currentPage=${currentPage}&pageSize=10`;
      // }
      if (!isRequestOrginIsBrowser) {
        requestHeader = {
          headers: {
            Authorization: `Bearer ${token}`,
            'X-Client-Type': 'STOS',
            ...headerInfo
          },
          credentials: 'include'
        };
      } else if (request.pathname?.includes('/wishlist') && isRequestOrginIsBrowser) {
        requestHeader = {
          headers: {
            'content-type': 'application/json',
            'X-Client-Type': 'STOS',
            credentials: 'include',
            ...headerInfo
          },
          credentials: 'include'
        };
      }
    }
    const Host = request.hostname || '';
    
    if (Host) {
      const {
        cookies: { sisUrl = '' }
      } = request;
      storeval = sisUrl || getHostName(Host);
    }
    const isAjioStore = ['', 'ajio', 'rilfnl'].includes(storeval);
    if (isAjioStore) storeval = 'ajio';

    if (storeval && !apiEndPoint.includes('store=')) {
      apiEndPoint = `${apiEndPoint}&store=${storeval}`;
    }
    if (!fetchProducts) {
      apiEndPoint = `${apiEndPoint}&products=${fetchProducts}`;
      dispatch(showLoader('fetching-next-facets'));
    }
    if (apiEndPoint.includes('allfilters=true')) {
      requestHeader = {
        ...requestHeader,
        timeout: 30000
      };
    }

    if (
      request.pathname?.includes('products/category') ||
      request.pathname?.includes('api/category') ||
      request.pathname?.includes('/s/') ||
      request.pathname?.includes('/search') ||
      request.pathname?.includes('/find')
    ) {
      let { A: authToken = '', U: userName = '', CI: customerUuid = '' } = request.cookies || {};
      const relevantPaths = ['/search', '/products/category', '/api/category', '/s/'];
      if (relevantPaths.some(path => request.pathname?.includes(path)) && isNode() && enableUserRelevancy) {
        authToken = searchAuth || authToken || '';
        customerUuid = searchUserId || customerUuid || '';
    }

    if(enableUserRelevancy && !request.pathname?.includes('/find')) {
        const params = {
          userId: customerUuid,
          personalisedUserRelevancy: true,
          ...(storedOffset && { prevProductListsOffset: storedOffset })
        };
  
        apiEndPoint = `${apiEndPoint}${apiEndPoint.includes("?") ? "&" : "?"}${qs.stringify(params, { encode: false })}`;
       
        if (!isRequestOrginIsBrowser) {
          requestHeader = {
            headers: {
              Authorization: `Bearer ${authToken}`,
              ...headerInfo
            },
          };
        }
      }

      const ABFlagObj = (searchAbFlagObj && JSON.parse(searchAbFlagObj)) || {};
      apiEndPoint = `${apiEndPoint}&segmentIds=${segmentIdsList}`;

      if (Object.keys(ABFlagObj)?.length > 0 && !apiEndPoint.includes('searchExp')) {
        // fix prod defect segmentIds added twice
        apiEndPoint = `${apiEndPoint}&${qs.stringify({ ...ABFlagObj })}`;
      }


      requestHeader = {
        ...requestHeader,
        headers: {
          ...requestHeader.headers,
          ...headerInfo,
          ...getJioAdsHeader(userAgent, isMsite)
        }
      };
    };

    if (
      (enableRushDeliveryFlag || enablePriorityDeliveryPhase2) &&
      pincode &&
      !apiEndPoint.includes('pincode=')
    ) {
      apiEndPoint = `${apiEndPoint}&pincode=${pincode}`;
    }

    if (
      enableRushDeliveryFlag &&
      rushDeliveryAvailability &&
      latitude &&
      longitude &&
      !apiEndPoint.includes('latitude=') &&
      !apiEndPoint.includes('longitude=')
    ) {
      apiEndPoint = `${apiEndPoint}&latitude=${latitude}&longitude=${longitude}`;
    }

    if (!apiEndPoint.includes('enableRushDelivery=')) {
      apiEndPoint = `${apiEndPoint}&enableRushDelivery=${enableRushDeliveryFlag}`;
    }

    if (!isRequestOrginIsBrowser && customertype) {
      apiEndPoint = `${apiEndPoint}&customertype=${customertype}`;
    }
    const isDynamicWidgetCall =
      isDynamicWidget === 'true' ||
      isDynamicWidget === true ||
      isCuratedWidget === 'true' ||
      isCuratedWidget === true;
    console.log("======= DEBUGGING POINT 3 =============")

    if (isDynamicWidgetCall) {
      const isFilterImprovementEnabledFromClientSide = isRequestOrginIsBrowser
        ? getEnableFilterImprovement(states)
        : isFilterImprovementEnabled;
      const isFilterImprovementPhase2EnabledFromClientSide = isRequestOrginIsBrowser
        ? getEnableFilterImprovementPhase2(states)
        : isFilterImprovementPhase2Enabled;
      const filterImprovementPayload = {
        sessionGenderContext: states?.facets?.sessionGenderContext || null,
        plpGender: states?.facets?.plpGender || null
      };

      let widgetVertexQueryParams = {};
      if (isRequestOrginIsBrowser) {
        widgetVertexQueryParams = getVertexQueryParams(
          states,
          storeNameValue,
          request.pathname,
          visitorId,
          encryptedUserId,
          'browse'
        );
      } else if (['ajiogram', 'luxe'].includes(normalizedStore)) {
        const storeConfig = normalizedStore === 'ajiogram' ? vertexEnabledAjiogram : vertexEnabledLuxe;
        if (storeConfig?.master && storeConfig?.vertexBrowseEnabled) {
          widgetVertexQueryParams = {
            vertexEnabled: true,
            ...(visitorId && { visitorId })
          };
        }
      } else if (vertexEnabledForSis && (childStores || []).map(s => s.toLowerCase()).includes(normalizedStore)) {
        widgetVertexQueryParams = {
          vertexEnabled: true,
          ...(visitorId && { visitorId }),
          ...(encryptedUserId && { userEncryptedId: encryptedUserId })
        };
      }

      let extrasObj = {
        enableSearchV4Flag,
        isPlpOnLandingLoadMore,
        isVertexCategoryEnabled: isVertexCategoryEnabled && searchAjioStore,
        previousSource,
        isPLAEnabled,
        customerUID,
        plpBannerAdsEnabled,
        plaAdsEliminationDisabled: plaAdsEliminationDisabledFlag,
        isFilterImprovementEnabled: isFilterImprovementEnabledFromClientSide,
        isFilterImprovementPhase2Enabled: isFilterImprovementPhase2EnabledFromClientSide,
        filterImprovementPayload:
          isFilterImprovementEnabledFromClientSide &&
          states?.facets?.sessionGenderContext &&
          states?.facets?.plpGender
            ? filterImprovementPayload
            : {},
        visitorId,
        isVertexStoreScopeEnabled,
        isVisualFilterEnabled,
        vertexQueryParams: widgetVertexQueryParams
      };

      if (isPlpOnLandingLoadMore) {
      console.log("======= DEBUGGING POINT 5 =============")

        const { widgetID = 'w1', widgetMinProdCount = '50', widgetName = '', widgetType = '' } = plpOnLandingFeedLogic || {};
        apiEndPoint = `/api/p/fetchDynamicProducts/${widgetID}/?${qs.stringify({
          widgetLevel: widgetType,
          platform: 'MOBILE',
          widgetName: widgetName || '',
          noOfProducts: parseInt(widgetMinProdCount),
          showViewAllWidget: true, // Need this as true for pagination
          pageSize: 20,
          currentPage: request?.query?.currentPage || 0,
          isPlpOnLandingLoadMore,
          previousSource,
          bannerType:
            isCuratedWidget === 'true' || isCuratedWidget === true ? 'CURATED_WIDGET' : '',
          store: storeval
        })}`;
      } else {
      console.log("======= DEBUGGING POINT 4 =============")

        apiEndPoint = setDynamicProductWidgetDetails(
          apiEndPoint,
          storeval,
          request.cookies,
          requestHeader,
          extrasObj
        );
      }
    }

    const categoryPaths = ["/products/category", "/api/category"];

    function addQueryParams(endpoint = '', payload = {}) {
      const { isVertexCategoryEnabled=false, visitorId='', customerUID='', sgAnonymousId='', previousSource='', categoryPaths=[], plpGender = '', sessionGenderContext = '', isPLAEnabled=false, isVertexSearchEnabled=false, visualFiltersEnabled=false, SearchFlag1=false, vertexEnabled, userEncryptedId='' } = payload;

      const [path, queryString] = endpoint.split("?");
      const searchParams = new URLSearchParams(queryString || "");
      if (vertexEnabled !== undefined) {
        searchParams.set('vertexEnabled', String(vertexEnabled));
      } else if (!searchParams.has('vertexEnabled') && searchAjioStore) {
        searchParams.set("vertexEnabled", String(isVertexCategoryEnabled));
      }
      if (visitorId && !searchParams.has("visitorId")) {
        searchParams.set("visitorId", visitorId);
      }
      if (userEncryptedId && !searchParams.has("userEncryptedId")) {
        searchParams.set('userEncryptedId', userEncryptedId);
      } else if (
        (isPLAEnabled || isVertexCategoryEnabled || isVertexSearchEnabled) &&
        (customerUID || sgAnonymousId) &&
        !searchParams.has('userEncryptedId')
      ) {
        searchParams.set("userEncryptedId", isLoggedIn ? sha256Hex(customerUID) : sha256Hex(sgAnonymousId));
      }
      if (previousSource && !searchParams.has("previousSource")) {
        searchParams.set("previousSource", previousSource);
      }
      if (plpGender && !searchParams.has('plpGender')) {
        searchParams.set('plpGender', plpGender);
      }
      if (sessionGenderContext && !searchParams.has('sessionGenderContext')) {
        searchParams.set('sessionGenderContext', sessionGenderContext);
      }
      if (isVisualFilterEnabled && !searchParams.has("visualFiltersEnabled") && isMsite) {
        searchParams.set("visualFiltersEnabled", true);
        searchParams.set("SearchFlag1", true);
      }
      return `${path}?${searchParams.toString()}`;
    }
    
    if ((isVertexCategoryEnabled && searchAjioStore && !enableUserRelevancy && categoryPaths.some(p => apiEndPoint.includes(p))) || isPLAEnabled) {
        apiEndPoint = addQueryParams(apiEndPoint, {searchAjioStore, isVertexCategoryEnabled, visitorId, customerUID, categoryPaths, previousSource, isPLAEnabled, isVertexSearchEnabled, sgAnonymousId});
    }
    // NOTE: FOR URGENCY DRIVER V2
    const channelType = request.deviceType?.toLowerCase() === 'mobile' ? 'MSITE' : 'WEB';
    const urgencyDriverV2MsiteConfig = isRequestOrginIsBrowser ? getUrgencyDriverV2Config(states) : serverUrgencyDriverV2MsiteConfig;
    const { enableMaster = 'OFF', plpPage = {} } = urgencyDriverV2MsiteConfig || {};
    const { enable: enablePlpPage = 'OFF', experimentName = '' } = plpPage || {};

    const enablePlpUrgencyDriverV2 =
      enableMaster === 'ON' && enablePlpPage === 'ON' && experimentName && channelType === 'MSITE';
    const plpEndpoints = [
      '/rilfnl/searchService/getProductDetails',
      '/rilfnl/products/search',
      '/rilfnl/products/category/',
      '/rilfnl/products/widgets/tags/',
      '/rilfnl/products/search',
      '/rilfnl/products/search',
      '/rilfnl/products/category/',
      '/rilfnl/products/category/',
      '/rilfnl/recentlyViewed',
      '/rilfnl/searchService/product',
      '/rilfnl/recommend/'
    ];

    if (enablePlpUrgencyDriverV2 && plpEndpoints.some(endpoint => apiEndPoint.includes(endpoint))) {
      requestHeader = {
        ...requestHeader,
        headers: {
          ...requestHeader.headers,
          'X-TENANT-ID': 'AJIO'
        }
      };
      apiEndPoint = `${apiEndPoint}&tagV2Enabled=true&tagExperiment=${experimentName}`;
    }

     if (
      isPlpOnLandingPage &&
      isPlpOnLandingLoadMore &&
      isFilterImprovementEnabled &&
      states?.plpOnLanding?.plpGender &&
      states?.plpOnLanding?.sessionGenderContext
    ) {
      const filterImprovementPayload = {
        sessionGenderContext: states?.plpOnLanding?.sessionGenderContext || null,
        plpGender: states?.plpOnLanding?.plpGender || null
      };
      apiEndPoint = addQueryParams(apiEndPoint, filterImprovementPayload);
    }

    if (isVisualFilterEnabled && isMsite) {
      const visualFilterPayload = {
        visualFiltersEnabled: true,
        SearchFlag1: true
      };
      apiEndPoint = addQueryParams(apiEndPoint, visualFilterPayload);
    }

    if (Object.keys(vertexQueryParams).length > 0) {
      apiEndPoint = addQueryParams(apiEndPoint, { ...vertexQueryParams, previousSource });
    }

    const { query= {} }= request;
    const plpBannerAdsEnabledParam = query?.ref !== 'banner' && plpBannerAdsEnabled;

    const resolvedState = state || (isRequestOrginIsBrowser ? readCookie('ST') || '' : '');
    const resolvedCity = city || (isRequestOrginIsBrowser ? readCookie('CT') || '' : '');
    const resolvedZone = zone || (isRequestOrginIsBrowser ? readCookie('ZN') || '' : '');

    //append osmos params
    apiEndPoint = `${apiEndPoint}&plaAdsProvider=${
      isPLAEnabled ? 'OSMOS' : 'JIOADS'
    }&plaAdsEliminationDisabled=${plaAdsEliminationDisabledFlag}&plpBannerAdsEnabled=${plpBannerAdsEnabledParam}&state=${resolvedState}&city=${resolvedCity}&zone=${resolvedZone}&userRestriction=${userRestriction}&userState=${userState}&deviceModel=web`;
    console.log("======= DEBUGGING POINT 6 =============")

    if (cohortHeaderValue) {
      requestHeader = {
        ...requestHeader,
        headers: {
          ...(requestHeader.headers || {}),
          userCohortValues: cohortHeaderValue
        }
      };
    }

    return fetcher(apiEndPoint, fetchGetJSONReqOpts(requestHeader))
      .then(res => {
        if (!res.ok) {
          console.log("======= DEBUGGING POINT 8 =============")

          return Promise.reject(res);
        }
        // dispatch(setExpiresTime(getExpiresFromResponse(res)));
        console.log("======= DEBUGGING POINT 7 =============")

        return res.json();
      })
      .then(async serviceRes => {
      console.log("======= DEBUGGING POINT 9 =============")

        let responseData = serviceRes;
        const { responseSource = 'Saas', pageCategory = '', bannerDetails={} } = responseData;

        if (isNode()) {
        console.log("======= DEBUGGING POINT 10 =============",{title: responseData?.title})

          dispatch(setPreviousSearchValues(responseSource));
          dispatch(setPageCategory(pageCategory));
        }
        //set osmos plp banners ads response
        if(plpBannerAdsEnabledParam && (isNode() || query?.currentPage===0)) {
          let osmosAds = getOsmosAdsInOrder(bannerDetails, osmosPlpBannerSlotsOrder);
          dispatch(fetchOsmosBannerAds(osmosAds));
        }

        if ((isSearchPage || isSearchRoute) && !_isEmpty(responseData?.storeInfo)) {
          responseData = {
            ...responseData,
            isSuggestStoreLink: true,
            storeRedirectURL:
              (responseData?.storeInfo === FLEEK_STORE
                ? properties.getProperty('fleekURL')
                : responseData?.storeInfo === 'street'
                ? properties.getProperty('streetURL')
                : responseData?.storeInfo === 'luxe'
                ? properties.getProperty('luxeURL')
                : properties.getProperty('parentUrl')) + _get(responseData, 'storeRedirectUri', '')
          };
        }
        const {
          title = '',
          imageURL = '',
          products = {},
          facets = [],
          isSlaNodesAvailable = false,
          pagination = {},
          sorts = [],
          categoryDescription = '',
          topdescription = '',
          freeTextSearch,
          autoCorrect,
          originalSearchTerm,
          isQueryExpanded = false,
          reasonForExpansion = '',
          organicResultCount = 0,
          correctedQuery = '',
          categoryforheader,
          categoryName,
          currentQuery,
          keywordRedirectUrl,
          metaElementData = [],
          productToggle,
          rilfnlBreadCrumbList = {},
          imageStyleType,
          categoryCode,
          isAdvanceFacetsEnabled,
          redirect = '',
          offerInfoCartData = [],
          dealStartTime = '',
          dealEndTime = '',
          endTimerVisibility,
          offerEndTime = '',
          timerStartBefore = '',
          topBrands = [],
          topBricks = [],
          topProducts = [],
          pageType,
          priceRevealMetaInfo = {},
          saleEndTime = null,
          saleStartTime = null,
          plpExtendedBanner = {},
          isSuggestStoreLink = false,
          showAdsOnNextPage: showAdsOnNextPageFromApi = false,
          spellingSuggestion,
          plpViewType,
          storeInfo = '',
          storeRedirectURL = '',
          brandDetails,
          productListsOffset = '',
          attributionToken = '',
          sessionGenderContext = '',
          plpGender = '',
          visualFilters = [],
          visualFiltersState = '',
          inlineFilters = [],
          quickFilters = []
        } = responseData;

        const updatedVisualFiltersState = pagination?.currentPage === 0 ? visualFiltersState : states?.facets?.visualFiltersState;

        if (pagination?.currentPage === 0) {
          if (productListsOffset) {
            dispatch(setProductOffSet(productListsOffset)); 
          }
        } else {
          if (typeof window !== "undefined") {
            const productListType = products.length > 0 ? products[0].productListType : null;
            if (productListType) {
              const EXPIRATION_TIME = 14 * 24 * 60 * 60 * 1000;

              const productData = {
                value: productListType,
                expiry: Date.now() + EXPIRATION_TIME,
              };

              //localStorage.setItem("productListType", JSON.stringify(productData));
            }
        
            if (productListsOffset) {
              sessionStorage.setItem("productListsOffset", productListsOffset);
            }
          }
        }

        let updatedUrl = redirect.replace('www.', '');
        const updatedRedirect =
          request?.query?.isBlp === 'true' && store === FLEEK_STORE ? '' : updatedUrl;

        let priceRevealSaleData = priceRevealMetaInfo;
        if (_isEmpty(priceRevealMetaInfo) && saleStartTime && saleEndTime) {
          priceRevealSaleData = {
            saleStartTime,
            saleEndTime
          };
        }
        const { currentPage, totalPages } = pagination;
        const { totalResults = _size(products) } = pagination;
        // if (totalResults === 0) {
        //   dispatch(showError('plp_Empty', 404));
        // }

        const queryParam = request.query;
        request = { ...request, totalResults, currentPage, freeTextSearch, brandDetails };
        if (Object.keys(browserRequest).length > 0) {
          browserRequest = {
            ...browserRequest,
            totalResults,
            currentPage,
            freeTextSearch,
            brandDetails
          };
        }

        const noProductsForPriceFilter =
          isRequestFromPlpOnLanding &&
          isPriceFilterFromPlpLandingPage &&
          !responseData?.products?.length;

        if (
          (facets.length > 0 && fetchFacetsOnly) ||
          isRequestFromPlpOnLanding ||
          isPlpOnLandingLoadMore
        ) {
          const {
            disabledDeliveryFacets = null,
            isPriorityDeliveryOffered = false
          } = await setDeliveryFacets(
            facets,
            isSlaNodesAvailable,
            enablePriorityDeliveryPhase2,
            priorityDeliverySLPTagsConfig,
            enableRushDeliveryFlag
          );

          const updatedFacets = disabledDeliveryFacets
            ? [...facets, disabledDeliveryFacets]
            : facets;

          if (isRequestFromPlpOnLanding) {
            const { facets = [], ...responseWithoutFacets } = responseData;

            dispatch(
              setPlpOnLandingResponse({
                ...responseWithoutFacets,
                  facets: updatedFacets
                },
                noProductsForPriceFilter
              )
            );
            if (!noProductsForPriceFilter && callBack) {
              callBack();
            }
            dispatch(hideLoader('fetching-filtered-products-on-landing'));
          }
          if (isPlpOnLandingLoadMore) {
            const { facets = [], ...responseWithoutFacets } = responseData;
            dispatch(
              updatePlpOnLandingResponse({
                ...responseWithoutFacets,
                facets: updatedFacets
              })
            );
            dispatch(showLoader('products-loader'));
          }
          if (facets.length > 0 && fetchFacetsOnly) {
            if (!noProductsForPriceFilter) {
              dispatch(
                setCurrentFacets(
                  updatedFacets,
                  totalResults,
                  isAdvanceFacetsEnabled,
                  queryParam,
                  isPriorityDeliveryOffered,
                  enablePriorityDeliveryPhase2,
                  enableRushDeliveryFlag,
                  sessionGenderContext,
                  plpGender,
                  visualFilters,
                  visualFiltersState,
                  inlineFilters,
                  quickFilters
                )
              );
            }

            dispatch(hideLoader('products-loader'));
            dispatch(hideLoader('fetching-next-facets'));
            dispatch(hideLoader('visual-filter-loader'));
            return;
          }
        }

        // release-20.12
        // code to use pageType from plp response
        // using pageType for isCategoryPage variable
        let pdpPage = false;
        // if pdp msite
        if (
          request &&
          request.deviceType?.toLowerCase() === 'mobile' &&
          headerInfo?.referer?.includes('/p/')
        ) {
          pdpPage = true;
        }
        const isCategoryPage = _lowerCase(pageType) === 'category page';
        if (_lowerCase(pageType) === 'curated page') {
          dispatch(getPlpExtendedBannerSuccess(plpExtendedBanner));
        }
        const filteredRequest = filterOutProperties(Object.keys(browserRequest).length > 0 ? browserRequest : request, ['baseUrl', 'freeTextSearch', 'body', 'brandDetails', 'totalResults',
          'currentPage', 'originalUrl', 'params', 'parsedParameterString', 'parsedPathName', 'pathname', 'query', 'url'])
        if (pdpPage) {
          dispatch(setRequestPDP(filteredRequest));
          dispatch(getYouMayAlsoLike(filteredRequest));
        } else {
          dispatch(setRequest(filteredRequest));
        }
        if (sorts.length > 0) {
          dispatch(setSorts(sorts));
        }
        if (facets.length > 0) {
          const {
            disabledDeliveryFacets = null,
            isPriorityDeliveryOffered = false
          } = await setDeliveryFacets(
            facets,
            isSlaNodesAvailable,
            enablePriorityDeliveryPhase2,
            priorityDeliverySLPTagsConfig,
            enableRushDeliveryFlag
          );
          const updatedFacets = disabledDeliveryFacets
            ? [...facets, disabledDeliveryFacets]
            : facets;

          if (!noProductsForPriceFilter) {
            dispatch(
              setCurrentFacets(
                updatedFacets,
                totalResults,
                isAdvanceFacetsEnabled,
                queryParam,
                isPriorityDeliveryOffered,
                enablePriorityDeliveryPhase2,
                enableRushDeliveryFlag,
                sessionGenderContext,
                plpGender,
                visualFilters,
                updatedVisualFiltersState,
                inlineFilters,
                quickFilters
              )
            );
          }
        }
        dispatch(
          setAdditionalInfo({
            freeTextSearch,
            categoryDescription,
            topdescription,
            autoCorrect,
            originalSearchTerm,
            categoryforheader,
            categoryName,
            currentQuery,
            keywordRedirectUrl,
            metaElementData,
            topBrands,
            topBricks,
            topProducts,
            productToggle,
            rilfnlBreadCrumbList,
            imageStyleType,
            categoryCode,
            curatedQuery,
            title,
            imageURL,
            redirect: updatedRedirect,
            offerInfoCartData,
            dealStartTime,
            dealEndTime,
            offerEndTime,
            endTimerVisibility,
            timerStartBefore,
            isCategoryPage,
            priceRevealMetaInfo: priceRevealSaleData,
            isSuggestStoreLink,
            showAdsOnNextPage: showAdsOnNextPageFromApi,
            spellingSuggestion,
            plpViewType,
            redirectionStore: storeInfo,
            storeRedirectURL,
            attributionToken,
            pagination,
            isQueryExpanded,
            reasonForExpansion,
            organicResultCount,
            correctedQuery,
            responseSource,
          })
        );
        if (isRequestOrginIsBrowser) {
          let plpresponse = {
            totalResults,
            request
          };
          if (currentPage > -1 && totalPages > -1 && currentPage === totalPages - 1) {
            plpresponse = { ...plpresponse, endOfPage: true };
          }
          PubSub.publish('PLP-API-RESPONSE', qs.stringify(plpresponse));
          const masterGA3 = getMasterGA3Flag() === 'ON';
          const masterGA4 = getMasterGA4Flag() === 'ON';
          const releaseGA4 = getReleaseGA4Flag() === 'ON';
          const isGA4Feature = getFeatureVariant('isGA4Feature');
          let is_GA4 = false;
          const storeName = getStoreName();
          if (
            isGA4Feature === '1' &&
            releaseGA4 &&
            masterGA4 &&
            !masterGA3 &&
            storeName === 'ajio'
          ) {
            is_GA4 = true;
          }
          if (is_GA4) {
            gtmEventPushPLP({
              event: 'plp_filter_interaction',
              event_category: 'plp_interaction',
              event_action: 'plp_filters_back_click',
              event_label: '',
              store_type: 'ajio',
              page_type: window.pageType || '',
              page_number: plpresponse?.request?.currentPage,
              plp_api_url: apiEndPoint
            });
          } else {
            gtmEventPush({
              event: 'plp_loading_scroll',
              page_number: plpresponse?.request?.currentPage,
              plp_api_url: apiEndPoint
            });
          }
        }
        if (appendNewProducts) {
          dispatch(appendDataToGrid(products, 'code', request.query, pdpPage, plpViewType));
        } else if(isInterventionProducts) {
          dispatch(setInterventionProducts(products, 'code', request.query, pdpPage, plpViewType));
        } else {
          dispatch(setGridData(products, 'code', request.query, pdpPage, plpViewType));
        }
        dispatch(hideLoader('products-loader'));
        dispatch(hideLoader('fetching-next-facets'));
        dispatch(hideLoader('fetching-filtered-products-on-landing'));
        dispatch(hideLoader('visual-filter-loader'));
        if (pdpPage) {
          dispatch(loadingMoreItemsOnScrollPDP(false));
        } else {
          dispatch(loadingMoreItemsOnScroll(false));
        }
      })
      .catch(err => {
        const statusCode = getErrorStatusCode(err);
        console.log("======= DEBUGGING POINT 11 =============", )

        // TODO-GA
        if (!isRequestOrginIsBrowser) {
          errorProcessor(err)
            .then(errorMessage => {
            console.log("======= DEBUGGING POINT 12 =============", errorMessage)

              ga.sendErrorToGA(err, errorMessage);
            })
            .catch(errorInErrorObject => {
              ga.sendErrorInErrorToGA(err, errorInErrorObject);
            });
        }
        dispatch(showError('plp', statusCode));
        dispatch(
          fetchingProductsErrored({
            isRowsAdding: false,
            isPageLoading: false,
            isRequestOrginIsBrowser,
            hasErrored: true,
            errorDetails: {
              status: err?.status,
              statusText: err?.statusText
            }
          })
        );
        dispatch(hideLoader('products-loader'));
        dispatch(hideLoader('fetching-next-facets'));
        dispatch(hideLoader('fetching-filtered-products-on-landing'));
        dispatch(hideLoader('visual-filter-loader'));
      }).finally(() => {
        if (callBack) { // basically we want callback to be executed everytime
          callBack();
        }

      });
  };
}

export function showAllFacetsCategories() {
  return {
    type: 'SHOW_ALL_FACETS_CATEGORIES',
    show: true
  };
}
export function hideAllFacetsCategories() {
  return {
    type: 'HIDE_ALL_FACETS_CATEGORIES',
    show: false
  };
}
export function toggleFacetGroup(id) {
  return {
    type: 'TOGGLE_FACET_GROUPS',
    id
  };
}

export function toggleFacet(id) {
  return {
    type: 'TOGGLE_FACET',
    id
  };
}

export function getRecommendationTrendsVibes({
  storeval = '',
  brickValue = '',
  segmnetValue = '',
  cohortIds = ''
}) {
  return dispatch => {
    try {
      let type = 'Cohort';
      let value = cohortIds;
      if(brickValue){
        type = 'Brick';
        value = brickValue;
      } else if(segmnetValue){
        type = 'Segment';
        value = segmnetValue;
      } else{
        type = 'Cohort';
        value = cohortIds || 'default';
      }
      const payload = {
        store: storeval || 'ajio',
        type,
        value
      };
      const apiEndPoint = `${properties.getProperty('parentUrl')}/api/home/trends`;
      return fetcher(
        apiEndPoint,
        fetchGetJSONReqOpts({
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(payload)
        })
       ).then(fetchGetJSONResHandler)
        .then(resp => {
          dispatch(setTrendsData(resp?.topTrends || []));
        })
        .catch(err => {
          dispatch(setTrendsData([]));
          console.log('err: ', err);
        });
    } catch (error) {
      console.log('Trend Vibes', error);
    }
  };
}